module.exports = __webpack_public_path__ + "static/media/logo_soy.d9b08cce.svg";